// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-footer {
    margin-top: 28px;
    padding: 42px 0 20px;
    color: #fff;
    background:
        radial-gradient(circle at top right, rgba(255, 255, 255, 0.08), transparent 26%),
        linear-gradient(135deg, #9f0718 0%, #d9001b 52%, #7c0817 100%);
}

.footer-no-top-gap {
    margin-top: 60px;
}

.footer-shell {
    width: 90%;
    max-width: 1400px;
    margin: 0 auto;
}

.footer-top {
    display: grid;
    grid-template-columns: minmax(320px, 1.2fr) minmax(0, 2fr);
    gap: 40px;
    align-items: start;
}

.footer-brand {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.footer-logo {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    color: #fff;
    text-decoration: none;
    font-size: 1.5rem;
    font-weight: 800;
    letter-spacing: 0.01em;
}

.footer-logo img {
    width: auto;
    height: 32px;
    display: block;
}

.footer-intro {
    max-width: 32rem;
    margin: 0;
    color: rgba(255, 255, 255, 0.86);
    font-size: 0.93rem;
    line-height: 1.68;
}

.footer-contact-card {
    display: grid;
    gap: 10px;
    margin-top: 2px;
    padding-top: 2px;
    max-width: 30rem;
}

.footer-contact-card-mobile {
    display: none;
}

.footer-contact-row {
    display: grid;
    grid-template-columns: 70px minmax(0, 1fr);
    gap: 10px;
    align-items: start;
}

.footer-contact-label {
    color: rgba(255, 255, 255, 0.64);
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.footer-contact-value {
    color: #fff;
    font-size: 0.92rem;
    line-height: 1.5;
    text-decoration: none;
}

.footer-contact-value:hover {
    text-decoration: underline;
}

.footer-nav-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
}

.footer-nav-group {
    min-width: 0;
}

.footer-nav-trigger {
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    text-align: left;
    cursor: default;
}

.footer-nav-title {
    margin: 0 0 14px;
    color: rgba(255, 255, 255, 0.96);
    font-size: 1rem;
    font-weight: 700;
}

.footer-nav-icon {
    display: none;
}

.footer-nav-list {
    display: grid;
    gap: 10px;
    margin: 0;
    padding: 0;
    list-style: none;
}

.footer-nav-link {
    display: inline-flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    line-height: 1.5;
    transition: transform 0.2s ease, color 0.2s ease;
}

.footer-nav-link:hover {
    color: #fff;
    transform: translateX(4px);
}

.footer-bottom {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    margin-top: 28px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.18);
    color: rgba(255, 255, 255, 0.72);
    font-size: 0.84rem;
    line-height: 1.5;
}

@media (max-width: 1100px) {
    .footer-top {
        grid-template-columns: 1fr;
        gap: 32px;
    }

    .footer-nav-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 640px) {
    .site-footer {
        padding: 34px 0 18px;
    }

    .footer-shell {
        width: min(92%, 100%);
    }

    .footer-top {
        gap: 12px;
    }

    .footer-brand {
        gap: 10px;
    }

    .footer-contact-card-desktop {
        display: none;
    }

    .footer-contact-card-mobile {
        display: grid;
    }

    .footer-nav-grid {
        grid-template-columns: 1fr;
        gap: 0;
        border-top: 1px solid rgba(255, 255, 255, 0.18);
    }

    .footer-nav-group {
        border-bottom: 1px solid rgba(255, 255, 255, 0.16);
    }

    .footer-nav-trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 0;
        cursor: pointer;
    }

    .footer-nav-title {
        margin: 0;
    }

    .footer-nav-icon {
        display: inline-flex;
        font-size: 1rem;
        line-height: 1;
        color: rgba(255, 255, 255, 0.8);
    }

    .footer-nav-list {
        display: none;
        gap: 8px;
        padding: 0 0 14px;
    }

    .footer-nav-list.is-open {
        display: grid;
    }

    .footer-contact-card {
        gap: 6px;
        margin-top: 8px;
        padding-top: 0;
        border-top: 0;
    }

    .footer-contact-row {
        grid-template-columns: 56px minmax(0, 1fr);
        gap: 8px;
        align-items: start;
        min-width: 0;
    }

    .footer-contact-label {
        font-size: 0.72rem;
        letter-spacing: 0.02em;
        white-space: nowrap;
    }

    .footer-contact-value {
        font-size: 0.84rem;
        line-height: 1.45;
        min-width: 0;
        white-space: normal;
        overflow: visible;
        text-overflow: clip;
        word-break: break-word;
        overflow-wrap: anywhere;
    }

    .footer-bottom {
        flex-direction: column;
        gap: 8px;
    }
}

@media (max-width: 420px) {
    .footer-contact-row {
        grid-template-columns: 1fr;
        gap: 2px;
    }

    .footer-contact-label {
        font-size: 0.68rem;
    }

    .footer-contact-value {
        font-size: 0.82rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX;;sEAEkE;AACtE;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,0DAA0D;IAC1D,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;IAC/C,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,MAAM;QACN,+CAA+C;IACnD;;IAEA;QACI,kDAAkD;IACtD;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,SAAS;QACT,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf,cAAc;QACd,+BAA+B;IACnC;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,eAAe;QACf,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,0CAA0C;QAC1C,QAAQ;QACR,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,mBAAmB;QACnB,iBAAiB;QACjB,mBAAmB;QACnB,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".site-footer {\n    margin-top: 28px;\n    padding: 42px 0 20px;\n    color: #fff;\n    background:\n        radial-gradient(circle at top right, rgba(255, 255, 255, 0.08), transparent 26%),\n        linear-gradient(135deg, #9f0718 0%, #d9001b 52%, #7c0817 100%);\n}\n\n.footer-no-top-gap {\n    margin-top: 60px;\n}\n\n.footer-shell {\n    width: 90%;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n.footer-top {\n    display: grid;\n    grid-template-columns: minmax(320px, 1.2fr) minmax(0, 2fr);\n    gap: 40px;\n    align-items: start;\n}\n\n.footer-brand {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.footer-logo {\n    display: inline-flex;\n    align-items: center;\n    gap: 12px;\n    color: #fff;\n    text-decoration: none;\n    font-size: 1.5rem;\n    font-weight: 800;\n    letter-spacing: 0.01em;\n}\n\n.footer-logo img {\n    width: auto;\n    height: 32px;\n    display: block;\n}\n\n.footer-intro {\n    max-width: 32rem;\n    margin: 0;\n    color: rgba(255, 255, 255, 0.86);\n    font-size: 0.93rem;\n    line-height: 1.68;\n}\n\n.footer-contact-card {\n    display: grid;\n    gap: 10px;\n    margin-top: 2px;\n    padding-top: 2px;\n    max-width: 30rem;\n}\n\n.footer-contact-card-mobile {\n    display: none;\n}\n\n.footer-contact-row {\n    display: grid;\n    grid-template-columns: 70px minmax(0, 1fr);\n    gap: 10px;\n    align-items: start;\n}\n\n.footer-contact-label {\n    color: rgba(255, 255, 255, 0.64);\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.footer-contact-value {\n    color: #fff;\n    font-size: 0.92rem;\n    line-height: 1.5;\n    text-decoration: none;\n}\n\n.footer-contact-value:hover {\n    text-decoration: underline;\n}\n\n.footer-nav-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 24px;\n}\n\n.footer-nav-group {\n    min-width: 0;\n}\n\n.footer-nav-trigger {\n    width: 100%;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    text-align: left;\n    cursor: default;\n}\n\n.footer-nav-title {\n    margin: 0 0 14px;\n    color: rgba(255, 255, 255, 0.96);\n    font-size: 1rem;\n    font-weight: 700;\n}\n\n.footer-nav-icon {\n    display: none;\n}\n\n.footer-nav-list {\n    display: grid;\n    gap: 10px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.footer-nav-link {\n    display: inline-flex;\n    align-items: center;\n    color: rgba(255, 255, 255, 0.8);\n    text-decoration: none;\n    line-height: 1.5;\n    transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.footer-nav-link:hover {\n    color: #fff;\n    transform: translateX(4px);\n}\n\n.footer-bottom {\n    display: flex;\n    justify-content: space-between;\n    gap: 24px;\n    margin-top: 28px;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.18);\n    color: rgba(255, 255, 255, 0.72);\n    font-size: 0.84rem;\n    line-height: 1.5;\n}\n\n@media (max-width: 1100px) {\n    .footer-top {\n        grid-template-columns: 1fr;\n        gap: 32px;\n    }\n\n    .footer-nav-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 640px) {\n    .site-footer {\n        padding: 34px 0 18px;\n    }\n\n    .footer-shell {\n        width: min(92%, 100%);\n    }\n\n    .footer-top {\n        gap: 12px;\n    }\n\n    .footer-brand {\n        gap: 10px;\n    }\n\n    .footer-contact-card-desktop {\n        display: none;\n    }\n\n    .footer-contact-card-mobile {\n        display: grid;\n    }\n\n    .footer-nav-grid {\n        grid-template-columns: 1fr;\n        gap: 0;\n        border-top: 1px solid rgba(255, 255, 255, 0.18);\n    }\n\n    .footer-nav-group {\n        border-bottom: 1px solid rgba(255, 255, 255, 0.16);\n    }\n\n    .footer-nav-trigger {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 12px;\n        padding: 14px 0;\n        cursor: pointer;\n    }\n\n    .footer-nav-title {\n        margin: 0;\n    }\n\n    .footer-nav-icon {\n        display: inline-flex;\n        font-size: 1rem;\n        line-height: 1;\n        color: rgba(255, 255, 255, 0.8);\n    }\n\n    .footer-nav-list {\n        display: none;\n        gap: 8px;\n        padding: 0 0 14px;\n    }\n\n    .footer-nav-list.is-open {\n        display: grid;\n    }\n\n    .footer-contact-card {\n        gap: 6px;\n        margin-top: 8px;\n        padding-top: 0;\n        border-top: 0;\n    }\n\n    .footer-contact-row {\n        grid-template-columns: 56px minmax(0, 1fr);\n        gap: 8px;\n        align-items: start;\n        min-width: 0;\n    }\n\n    .footer-contact-label {\n        font-size: 0.72rem;\n        letter-spacing: 0.02em;\n        white-space: nowrap;\n    }\n\n    .footer-contact-value {\n        font-size: 0.84rem;\n        line-height: 1.45;\n        min-width: 0;\n        white-space: normal;\n        overflow: visible;\n        text-overflow: clip;\n        word-break: break-word;\n        overflow-wrap: anywhere;\n    }\n\n    .footer-bottom {\n        flex-direction: column;\n        gap: 8px;\n    }\n}\n\n@media (max-width: 420px) {\n    .footer-contact-row {\n        grid-template-columns: 1fr;\n        gap: 2px;\n    }\n\n    .footer-contact-label {\n        font-size: 0.68rem;\n    }\n\n    .footer-contact-value {\n        font-size: 0.82rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
